import { render, staticRenderFns } from "./LoginWXRedirect.vue?vue&type=template&id=202bc786&"
import script from "./LoginWXRedirect.vue?vue&type=script&lang=js&"
export * from "./LoginWXRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports